// ** MUI Imports
import { styled } from '@mui/material/styles'
import Box, { BoxProps } from '@mui/material/Box'

// ** Types
import { BlankLayoutProps } from './types'

// ** Iframe Utils
import { isIframeContext, isIframeRequest } from '@/src/utils/iframeUtils'

// ** Components
import IframeLogoutButton from '@/src/gygComponents/IframeLogoutButton'

// Styled component for Blank Layout component
const BlankLayoutWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100vh',

  // For V1 Blank layout pages
  '& .content-center': {
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(5)
  },

  // For V2 Blank layout pages
  '& .content-right': {
    display: 'flex',
    minHeight: '100vh',
    overflowX: 'hidden',
    position: 'relative'
  }
}))

const BlankLayout = ({ children }: BlankLayoutProps) => {
  const isIframe = isIframeContext() || isIframeRequest()

  return (
    <BlankLayoutWrapper
      className={`layout-wrapper ${isIframe ? 'iframe-context' : ''}`}
      sx={{
        ...(isIframe && {
          height: '600px',
          minHeight: '600px',
          maxHeight: '600px'
        })
      }}
    >
      {/* Logout button for iframe context */}
      {isIframe && <IframeLogoutButton position='bottom-right' />}

      <Box
        className='app-content'
        sx={{
          overflow: 'hidden',
          minHeight: isIframe ? '600px' : '100vh',
          height: isIframe ? '600px' : 'auto',
          position: 'relative'
        }}
      >
        {children}
      </Box>
    </BlankLayoutWrapper>
  )
}

export default BlankLayout
